import "./AboutUsHero.css";

function AboutUsHero({ eyebrow, title, text, portraitSrc, portraitAlt, name, role }) {
  return (
    <section className="about-hero-container fade-in-up">
      <div className="about-hero-inner hover-lift">
        <div className="about-hero-copy">
          {eyebrow && <span className="about-hero-eyebrow">{eyebrow}</span>}
          <h1>{title}</h1>
          <p>{text}</p>
        </div>

        {portraitSrc && (
          <div className="about-hero-portrait">
            <img
              src={portraitSrc}
              alt={portraitAlt || name || "Teammitglied von Fit2Clean"}
              className="about-hero-portrait-img"
            />
            {(name || role) && (
              <div className="about-hero-meta">
                {name && <span className="about-hero-name">{name}</span>}
                {role && <span className="about-hero-role">{role}</span>}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default AboutUsHero;
